import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.36 11.233a1 1 0 0 0-.36.769c0 1.998-.537 3.085-.956 3.628L4.372 8.96c.55-.425 1.635-.958 3.628-.958a1 1 0 0 0 .768-.36l4.3-5.16 4.45 4.452-5.159 4.299zm7.347-4.938l-6-6a.966.966 0 0 0-.752-.292.998.998 0 0 0-.724.358L7.524 6.01c-4.103.155-5.293 2.292-5.419 2.544-.192.385-.117.85.188 1.155l3.293 3.293-5.293 5.293a.999.999 0 1 0 1.414 1.414L7 14.416l3.293 3.293a1 1 0 0 0 1.154.187c.252-.126 2.39-1.315 2.544-5.42l5.65-4.706a1.003 1.003 0 0 0 .066-1.475z"
});

var SvgPinMajorMonotone = function SvgPinMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgPinMajorMonotone as S };
